import { css } from "styled-components";

export const cellContainerStyles = css`
  font-family: "Open Sans", sans-serif;
  color: #384a5d;
  font-size: 13px;
  font-weight: 400;
  padding: 6px 5px 5px;
  white-space: nowrap;
  text-align: left;
  appearance: none;
  background: none;
  width: 100%;
  height: 30px;
  box-sizing: border-box;
  outline: none;
  border-radius: 6px;
  transition: border 0.2s, background 0.2s;

  &:focus {
    border: 1px solid #278dc1;
    background: rgba(39, 141, 193, 0.05);
  }

  &:disabled {
    border: none;
  }
`;

export const editableCellStyles = css`
  border: 1px solid rgba(0, 0, 0, 0.05);
`;

export const focusVisibleCellStyles = css`
  &:focus-visible {
    outline: none;
    border: 1px solid #278dc1;
    border-radius: 6px;
    background: rgba(39, 141, 193, 0.05);
    transition: border 0.2s, background 0.2s;
  }
`;
